<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>
    <div class="sl-card">
        <!-- Card Title -->
        <div class="sl-card__title">
            {{ $t('card.lens_price.title') }}
        </div>

        <!-- Lens Price -->
        <div class="sl-card-details__price-line">
            <div class="sl-card-details__price-line-label">
                {{ getLabel(order) }}
            </div>

            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                <template v-if="!orderIsMoreExpensiveThanCatalogPrice">
                    <span>{{ order.currency_code }}</span>
                    <span>{{ $f(order.price, 'decimal:2') }}</span>
                </template>
            </div>
        </div>

        <!-- Supplement Prices -->
        <div
            v-for="supplement in order.supplements"
            :key="supplement.code"
            class="sl-card-details__price-line"
        >
            <div class="sl-card-details__price-line-label">
                +

                <template v-if="supplement.quantity > 1">
                    {{ supplement.quantity }}&times;
                </template>

                {{ supplement.article_label || supplement.article_code }}
            </div>

            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                <template v-if="!orderIsMoreExpensiveThanCatalogPrice">
                    <span>{{ supplement.currency_code }}</span>
                    <span>{{ $f(supplement.price, 'decimal:2') }}</span>
                </template>
            </div>
        </div>

        <!-- Subtotal -->
        <div
            v-if="!orderIsMoreExpensiveThanCatalogPrice && discount < 0"
            class="sl-card-details__price-line border-t border-gray-200 pt-2 mt-1"
        >
            <div class="sl-card-details__price-line-label">
                {{ $t('common.subtotal') }}
            </div>

            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                <span>{{ order.currency_code }}</span>
                <span>{{ $f(subtotal, 'decimal:2') }}</span>
            </div>
        </div>

        <!-- Discount -->
        <div
            v-if="!orderIsMoreExpensiveThanCatalogPrice && discount < 0"
            class="sl-card-details__price-line"
        >
            <div class="sl-card-details__price-line-label">
                {{ $t('common.discount') }}
            </div>

            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                <span>{{ order.currency_code }}</span>
                <span>{{ $f(discount, 'decimal:2') }}</span>
            </div>
        </div>

        <!-- Total -->
        <div
            v-if="!orderIsMoreExpensiveThanCatalogPrice &&
                (order.supplements.length || order.special_price !== null)"
            class="sl-card-details__price-line border-t border-gray-200 pt-2 mt-1"
        >
            <div class="sl-card-details__price-line-label">
                {{ $t('common.total') }}
            </div>

            <div
                class="sl-card-details__price-line-value"
                :class="{ 'blur': !isPriceVisible }"
            >
                <template v-if="!orderIsMoreExpensiveThanCatalogPrice">
                    <span>{{ order.currency_code }}</span>
                    <span>{{ $f(order.total, 'decimal:2') }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
export default
{
    name: 'LensPriceCard',

    props:
    {
        order:
        {
            type:     Object,
            required: true,
        },
    },

    computed:
    {
        // Do not display price to the customer if it's more than the catalog price.
        orderIsMoreExpensiveThanCatalogPrice()
        {
            if(this.order.special_price === null)
            {
                return false;
            }

            return this.order.special_price > this.subtotal;
        },

        isPriceVisible()
        {
            return this.$store.state.pricesVisible;
        },

        subtotal()
        {
            return this.order.supplements.reduce(
                (acc, s) => acc + s.price * s.quantity,
                this.order.price
            );
        },

        discount()
        {
            if(this.order.special_price === null)
            {
                return 0;
            }

            return this.order.special_price - this.subtotal;
        },
    },

    methods:
    {
        getLabel(line)
        {
            return line.article.label || line.article.code || '';
        },
    },
};
</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="css" scoped>
</style>
